import React from 'react';
import ComparisonPage from './ComparisonPage';

/**
 * Phase 0b3 — refactored to use the config-driven `ComparisonPage`
 * so all competitor pages share consistent Answer-First H1, feature
 * table, migration FAQ, and SoftwareApplication schema.
 * All Jackrabbit-specific content now lives in `comparisons.js`.
 */
export default function VsJackrabbitSwim() {
    return <ComparisonPage slug="jackrabbit-swim" />;
}
